import { Component, OnInit } from "@angular/core";
import { jwtDecode } from "jwt-decode";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { DataService } from "@app/services/data.service";
import { AccountService } from "@app/services/account.service";
import { FilterService } from "@app/services/filter.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
              private route: ActivatedRoute,
              private dataService: DataService,
              private http: HttpClient,
              private accountService: AccountService,
              public filterService: FilterService) {}

  organizationCode = "";
  userRoles = "";
  showTable = true;
  showRegistry = true;
  navItems = [

    // {
    //   link: "/sign-demo",
    //   title: "КЕП Демо",
    // },
    {
      link: "/reserves",
      title: "Запаси",
      order: "1",
    },
    {
      link: "/supplies",
      title: "Поставки",
      order: "0",
    },
    {
      link: "/organizations",
      title: "Організації",
      order: "2",
    },
    {
      link: "/recipients",
      title: "Отримувачі",
      order: "3",
    },
    // {
    //   link: "/distributions",
    //   title: "Розподіли",
    //   order: "4",
    // },
  ];

  ngOnInit(): void {

    this.organizationCode = (
      jwtDecode(localStorage["access_token"]) as any
    ).organizationInfo.code;
    this.userRoles = (
      jwtDecode(localStorage["access_token"]) as any
    ).realm_access.roles.join(" ");
    this.onShowMyOrganization({ state: true });
  }

  onShowMyOrganization({ state }: { state: boolean; }): void {
    console.log("User roles: " + this.userRoles);
    this.dataService.organizationCode = state ? this.organizationCode : "";

    if (this.userRoles.indexOf("doz-member-role") > -1) {
      this.dataService.userRole = "DOZ";
      this.navItems = [];
      this.navItems.push({
        link: "/supplies",
        title: "Поставки",
        order: "0",
      });
      this.navItems.push({
        link: "/recipients",
        title: "Отримувачі",
        order: "3",
      });
      this.navItems.push({
        link: "/distributions/doz",
        title: "Розподіли",
        order: "4",
      });
      return;
    }

    if (this.userRoles.indexOf("logistics-manager") > -1) {
      this.dataService.userRole = "DOZ";
      this.navItems.forEach((item, index) => {
        if (item.link === "/organizations") {
          this.navItems.splice(index, 1);
        }
      });
      this.navItems.push({
        link: "/distributions/doz",
        title: "Розподіли",
        order: "4",
      });
      return;
    }
    if (this.userRoles.indexOf("logistics-mpu-manager") > -1) {
      this.dataService.userRole = "MZU";
      console.log("User type:", this.dataService.userRoleValue.getValue());

      this.navItems.push({
        link: "/distributions/mzu",
        title: "Розподіли",
        order: "4",
      });

      return;
    }

    if (this.userRoles.indexOf("logistics-expert") > -1) {
      this.dataService.userRole = "ZOZ";
      return;
    }

    this.dataService.userRole = "UNKNOWN";
  }

  onAppContentChange({ state }: { state: 1 | 2; }): void {
    this.showTable = state === 2;
  }

  showFilterButtons(): boolean {
    if (this.filterService.goodSpecificationsShowed) {
      return false;
    }
    return ["/supplies", "/reserves"].includes(this.currentPath());
  }

  currentPath(): string {
    return this.router.routerState.snapshot.url;
  }

  isPage(path: string): boolean {
    return [`/${path}`].includes(this.router.routerState.snapshot.url);
  }

  showFilter(): void {
    if ("/supplies" === this.currentPath()) {
      this.filterService.showSuppliesFilter = true;
    } else if ("/reserves" === this.currentPath()) {
      this.filterService.showReservesFilter = true;
    }
    this.filterService.loadDistinctsForDropdowns();
  }

  trackByIndex(index: number): number {
    return index;
  }

  deleteSuppliesFilterItem(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.suppliesStateChanged();
    }
  }

  deleteReservesFilterItem(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.reservesStateChanged();
    }
  }

  resetFilter() {
    this.filterService.resetFilter(this.currentPath());
  }

  deleteFilterItemDate(dateType: string) {
    if ("actualDate" === dateType) {
      this.filterService.supplies.actualDate = null;
      this.filterService.suppliesStateChanged();
    } else if ("expectedDate" === dateType) {
      this.filterService.supplies.expectedDate = null;
      this.filterService.suppliesStateChanged();
    } else if ("controlDate" === dateType) {
      this.filterService.reserves.controlDate = null;
      this.filterService.reservesStateChanged();
    }
  }

  getDirectionLabel(id: string): string {
    const match = this.filterService.suppliesOptions.directions.find(dir => dir.value === id);
    return match ? match.label : id.toString(); // fallback to id if label not found
  }
}
